import styled from 'styled-components';
import theme from '../theme';
import fn from '../../helpers/fn';

export default fn(__filename, styled.div`
  margin-bottom: ${2 * theme.unit}px;

  &:last-child {
    margin-bottom: 0;
  }

  ${({ flex }) => flex && `
    flex: ${flex};
  `}
`);



// WEBPACK FOOTER //
// ./src/components/fields/Field.js